import store from '@/store'

/**
 * Check for user group
 * @param {string[]} groups Array of user groups
 * @returns {Boolean} User is member of group
 */
export default function (groups) {
  if (store.state.user.data.groups) {
    for (let i = 0; i < groups.length; i++) {
      if (store.state.user.data.groups.indexOf(groups[i]) >= 0) {
        return true
      }
    }
  }

  return false
}
